import { createFileRoute } from "@tanstack/react-router";

import { PraxaNotificationCenter } from "../components/praxa/PraxaNotificationCenter";

export const Route = createFileRoute("/w/$workspaceId/notifications/")({
  component: PraxaNotificationsRoute,
});

function PraxaNotificationsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaNotificationCenter workspaceId={workspaceId} />;
}
